<template>
    <div>
    <div class="activity-main">
         <!-- 头部 -->
      <headers></headers>
        <section class="ban-bg">

        </section>
        <section class="ban">
            <div class="col">
                <div>
                    <h1 class="title1">即刻加入平台会员 尊享众多精彩权益</h1>

                    <p style="
                    font-weight: 300;
                    font-size: 30px;
                    margin-top: 50px;
                    text-align: center;
                    color: #FFFFFF;
                    line-height: 60px;">ExpoSCM旗下众多数字化产品和增值服务，全面覆盖展装企业日常管理和市场拓展需要</p>
                </div>
            </div>
        </section>
        <div style="">
            <section class="col" style="padding-top: 50px;">
                <div class="div1" id="j-nav-10">
                    <a class="md jrwm active" href="javascript:;">加入我们</a>
                    <i></i>
                    <a class="md jrfs" href="#jrfs">加入方式</a>
                    <i></i>
                    <a class="md sqjr" href="#sqjr">申请加入</a>
                    <i></i>
                    <a class="md lxwm" href="#lxwm">联系我们</a>
                </div>
                <h4 class="title5" style="margin-top: 98px;margin-bottom: 20px;">加入优势</h4>
                <ul class="ul1">
                    <li>
                        <div>
                            <img src="../images/img-fj.png" alt="">
                            <p class="s1">抢占先机</p>
                            <p class="s2">全方位权益</p>
                            <p class="s3">进入平台自营&合作主场项目推荐搭建商行列，更快获得业务增长机会</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-ss.png" alt="">
                            <p class="s1">提升效率</p>
                            <p class="s2">数字化赋能</p>  
                            <p class="s3">展装云、设计云、主场云，店铺展示四大数字化工具助力降本增效</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-shu.png" alt="">
                            <p class="s1">树立品牌</p>
                            <p class="s2">多维度推广</p>
                            <p class="s3">平台自营宣发渠道，多种方式推广，提升企业知名度</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-xj.png" alt="">
                            <p class="s1">降低成本</p>
                            <p class="s2">集约化采购</p>
                            <p class="s3">享受平台集约化采购优惠价，实惠多多，福利多多</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../images/img-qc.png" alt="">
                            <p class="s1">增加收益</p>
                            <p class="s2">创新型增收</p>
                            <p class="s3">加入平台创新增收计划，稳定提升收益</p>
                        </div>
                    </li>
                </ul>
                <h4 class="title5" style="margin-top: 98px;margin-bottom: 20px;">尊享礼包</h4>
                <div class="libao-list">
                    <div>
                        <dl>
                            <dt class="dt1"><span>数字产品礼包</span></dt>
                            <dd>
                                <ul>
                                    <li><img src="../images/img-lb-1.png" alt=""><span>让管理更省心</span></li>
                                    <li><img src="../images/img-lb-2.png" alt=""><span>让设计更高效</span></li>
                                    <li><img src="../images/img-lb-3.png" alt=""><span>让发展更迅速</span></li>
                                </ul>

                                <p>具体内容请参看“<a href="#hyqy">会员权益</a>”</p>
                            </dd>
                        </dl>
                    </div>
                    <div>
                        <dl>
                            <dt class="dt2"><span>主场服务礼包</span></dt>
                            <dd>
                                <ul>
                                    <li><img src="../images/img-lb-4.png" alt=""><span>推荐搭建商机会</span></li>
                                    <li><img src="../images/img-lb-5.png" alt=""><span>保证金部分减免</span></li>
                                    <li><img src="../images/img-lb-6.png" alt=""><span>PLUS会员礼遇</span></li>
                                </ul>
                                <p class="p2">具体内容请参看“<a href="#hyqy">会员权益</a>”</p>
                            </dd>
                        </dl>
                    </div>
                    <div>
                        <dl>
                            <dt class="dt3"><span>实用资源礼包</span></dt>
                            <dd>
                                <ul>
                                    <li><img class="img2" src="../images/img-lb-7.png" alt=""><span>海量销售线索分享</span></li>
                                    <li><img class="img2" src="../images/img-lb-8.png" alt=""><span>优质工厂分享</span></li>
                                    <li><img class="img2" src="../images/img-lb-9.png" alt=""><span>展保云联券 x3</span></li>
                                    <li><img class="img2" src="../images/img-lb-10.png" alt=""><span>设计云下载劵 x60</span>
                                    </li>
                                </ul>
                                <p class="p2">具体内容请参看“<a href="#hyqy">会员权益</a>”</p>
                            </dd>
                        </dl>
                    </div>
                </div>
                <h4 class="title5" style="margin-top: 98px;margin-bottom: 20px;">我们的用户</h4>
            </section>
            <div style="background-color: #F9FAFB;">
                <ul class="logo-tab" id="logo-tab">
                    <!-- <li class="active">全部分类</li> -->
                    <li class="active">平台会员</li>
                    <li>产品用户</li>
                    <li>自营&合作展会</li>
                </ul>
                <section class="brand-list2-box" id="logo-list-box">
                    <ul class="brand-list2" id="logo-list">
                        <div class="logo1">
                            <li><img src="../images/logo/1神州.jpg" alt=""></li>
                            <li><img src="../images/logo/2飞鹰超华.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/3联展.jpg" alt=""></li>
                            <li><img src="../images/logo/4道田.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/5全荣.jpg" alt=""></li>
                            <li><img src="../images/logo/6石拓.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/7伊鸣.jpg" alt=""></li>
                            <li><img src="../images/logo/8半分利.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/9雅冠.jpg" alt=""></li>
                            <li><img src="../images/logo/10易构.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/11同业圆通.jpg" alt=""></li>
                            <li><img src="../images/logo/12超越无限.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/13冠恒.jpg" alt=""></li>
                            <li><img src="../images/logo/14君得.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/15司创.jpg" alt=""></li>
                            <li><img src="../images/logo/16优秘.jpg" alt=""></li>
                        </div>
                        <div class="logo1">
                            <li><img src="../images/logo/17伊洛.jpg" alt=""></li>
                            <li><img src="../images/logo/18雅申.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/19鼎尖.jpg" alt=""></li>
                            <li><img src="../images/logo/20汉展.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/21红蝠.jpg" alt=""></li>
                            <li><img src="../images/logo/22优秘.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/23澜扩.jpg" alt=""></li>
                            <li><img src="../images/logo/24美佳.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/25墨创.jpg" alt=""></li>
                            <li><img src="../images/logo/26天府.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/27中交联创.jpg" alt=""></li>
                            <li><img src="../images/logo/28武汉中博.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/29东万华.jpg" alt=""></li>
                            <li><img src="../images/logo/30海南华章.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/31展保云联.jpg" alt=""></li>
                            <li><img src="../images/logo/32政文.jpg" alt=""></li>
                        </div>
                        <div class="logo2">
                            <li><img src="../images/logo/33汇创.jpg" alt=""></li>
                            <li><img src="../images/logo/34优舍.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/35京兮.jpg" alt=""></li>
                            <li><img src="../images/logo/36中食.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/37饲料.jpg" alt=""></li>
                            <li><img src="../images/logo/38餐饮.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/39零售.jpg" alt=""></li>
                            <li><img src="../images/logo/40特许加盟.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/41集约化畜牧.jpg" alt=""></li>
                            <li><img src="../images/logo/42畜牧.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/43成都健身.jpg" alt=""></li>
                            <li><img src="../images/logo/44混凝土.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/45烘培.jpg" alt=""></li>
                            <li><img src="../images/logo/46成都广告.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/47成都幼教.jpg" alt=""></li>
                            <li><img src="../images/logo/48成都照明.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/49成都印刷.jpg" alt=""></li>
                            <li><img src="../images/logo/50成都环保.jpg" alt=""></li>
                        </div>
                        <div class="logo3">
                            <li><img src="../images/logo/51生活用纸.jpg" alt=""></li>
                            <li><img src="../images/logo/52科学技术.jpg" alt=""></li>
                        </div>
                    </ul>
                </section>
            </div>

            <section id="jrfs" class="col" style="padding-top: 50px; padding-bottom: 50px;">
                <h4 class="title5" style="margin-top: 78px;margin-bottom: 36px;">加入方式</h4>
                <div class="div2 dlStyule">
                    <!-- <dl>
                        <dt class="dt1">普通会员</dt>
                        <dd>
                            <p>
                                <label for="">诚信保证金</label>
                                <span>
                                    <font class="font1">10万</font>元
                                </span>
                            </p>
                            <p>
                                <label for="">第三方系统服务费</label>
                                <span>
                                    <font class="font1">1800</font>元/年
                                </span>
                            </p>
                        </dd>
                    </dl> -->

                    <dl style="width: 100%;">
                        <dt class="dt2">VIP会员</dt>
                        <dd>
                            <p>
                                <label for="" style="width: 500px;">诚信保证金</label>
                                <span>
                                    <font class="font2">免收取</font>
                                </span>
                            </p>
                            <p>
                                <label for="" style="width: 500px;">平台服务费</label>
                                <span>
                                    <font class="font2">8800</font>元/年
                                </span>
                            </p>
                        </dd>
                    </dl>
                </div>
                <h4 id="hyqy" class="title5" style="margin-top: 78px;margin-bottom: 5px;">会员权益</h4>
                <p class="note" style="margin-top: 5px">市场参考价值超过<font>5万元</font>
                </p>

                <table align="center" class="table1" style="margin-top: 20px;">
                    <thead  align="middle" valign="center">
                        <tr>
                            <th style="vertical-align: middle">项目</th>
                            <th>内容</th>
                            <th>说明</th>
                            <th>VIP会员</th>
                            <!-- <th>普通会员</th> -->
                        </tr>
                    </thead>
                    <tbody  align="middle" valign="center">
                        <tr>
                            <td rowspan="2">展保云联劵</td>
                            <td>免费赠送</td>
                            <td>可兑换全国范围，不限展台面积，保额600万100万的展台保险(市场参考价值3000)</td>
                            <td>3张</td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>专享渠道</td>
                            <td>可享受展保云联VIP价格购买全国展台安全保障服务</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <tr>
                            <td rowspan="4">平台资源</td>
                            <td>推荐搭建服务</td>
                            <td>vip会员 免收诚信保证金（推荐服务费5%）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <!-- <tr>
                            <td>vip会员 免收诚信保证金（推荐服务费5%）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                        </tr>-->
                        <tr> 
                            <td>现场VIP礼遇</td>
                            <td>平台自营&合作展会现场Plus礼遇</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <tr>
                            <td>物流优先</td>
                            <td>平台自运营展会物流优先服务（不违反主办方规定前提下）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>保证金优惠</td>
                            <td>平台自营&合作展会保证金优惠（单场展会10万封顶）</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td rowspan="2">行业推广</td>
                            <td>专享广告</td>
                            <td>设计云官网顶部banner广告位1个月发布权(市场参考价值1000元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>软文推广</td>
                            <td>平台合作自媒体软文推广一次</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td rowspan="2">设计云</td>
                            <td>企业店铺</td>
                            <td>线上展装企业展示空间(市场参考价值3000元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td><img src="../images/icon-yes.svg" alt=""></td> -->
                        </tr>
                        <tr>
                            <td>图纸下载</td>
                            <td>全年赠送60套图纸免费下载(市场参考价值3000元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td rowspan="5">展装云</td>
                            <td>专业版</td>
                            <td>展装企业管理系统(市场参考价值5800元)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>行业资讯</td>
                            <td>掌握行业一手资讯</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>展会排期</td>
                            <td>了解全国展会信息</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>信息对接</td>
                            <td>搭建需求信息对接</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <tr>
                            <td>优质工厂</td>
                            <td>全国优质工厂资源</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                            <!-- <td>-</td> -->
                        </tr>
                        <!-- <tr>
                            <td rowspan="2">主场云</td>
                            <td>基础版</td>
                            <td>主场业务系统工具(市场参考价值5800)</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                        </tr> -->
                        <!-- <tr>
                            <td>合作共赢计划</td>
                            <td>数字赋能主场增收</td>
                            <td><img src="../images/icon-yes.svg" alt=""></td>
                        </tr> -->

                    </tbody>
                </table>

                <h4 class="title5" style="margin-top: 88px; margin-bottom: 20px;">加入条件</h4>
                <div class="jrtj">
                    <div class="d1">
                        <div><img src="../images/img-jb.png" alt=""><span>申请企业注册资金 100 万以上</span></div>
                        <div><img src="../images/img-date.png" alt=""><span>企业成立年限3年以上</span></div>
                        <div><img src="../images/img-bz.png" alt=""><span>企业近 3 年无不良征信记录</span></div>
                    </div>
                    <div class="d2"><img src="../images/img-jz.png" alt=""><span>具有省级以上行业主管部门颁发的会展工程资质优先</span></div>
                </div>
                <p class="note">
                    <font>*仅限与本平台有以往合作历史的企业申请，名额有限，具体是否吸纳为会员以最终结果查询为准</font>
                </p>

                <h4 id="sqjr" class="title5" style="margin-top: 88px; margin-bottom: 20px;">申请加入</h4>
                <div>
                    <ul class="tab1 istab1">
                        <li class="tab-status-0 active xc-off">提交企业信息</li>
                        <li class="tab-status-1 xc-off">企业信息审核</li>
                        <li class="tab-status-2">加入VIP会员</li>
                        <li class="tab-status-3">申请审核</li>
                        <li class="tab-status-4">申请成功</li>
                    </ul>
                    <ul class="tab1 istab2">
                        <li class="tab-status-5 active xc-off">VIP会员续费审核</li>
                        <li class="tab-status-6 xc-off">VIP会员续费成功</li>
                    </ul>
                    <div style="margin-top: 20px;">
                        <div class="" id="box-status-0">
                            <ul class="qyxx">
                                <li>
                                    <div>企业信息</div>
                                </li>
                                <li>
                                    <div class="label">企业名称<font style="color: #e54c4a;">*</font></div>
                                    <div class="box"><input type="text" id="qyxx-company" maxlength="50"
                                            placeholder="请输入企业名称" autocomplete="new-password"></div>
                                </li>
                                <li>
                                    <div class="label">社会统一信用代码<font style="color: #e54c4a;">*</font></div>
                                    <div class="box"><input type="text" id="qyxx-pay_tax" maxlength="30"
                                            placeholder="请输入社会统一信用代码" autocomplete="new-password"></div>
                                </li>
                                <li>
                                    <div class="label">营业执照<font style="color: #e54c4a;">*</font></div>
                                    <div class="box">
                                        <input id="file-yyzz" type="file" accept="image/*,application/pdf"
                                            style="display:none">
                                        <a id="j-btn-yyzz" class="btn-up" href="javascript:;">上传营业执照</a>
                                        <span class="file-name" id="file-name-yyzz"></span>
                                    </div>
                                </li>
                                <li>
                                    <div class="label">资质文件</div>
                                    <div class="box">
                                        <input id="file-zxwj" type="file" accept="image/*,application/pdf"
                                            style="display:none">
                                        <a id="j-btn-zxwj" class="btn-up" href="javascript:;">上传资质文件</a>
                                        <span class="file-name" id="file-name-zxwj"></span>
                                        <span
                                            style="color: #999; font-size: 12px; margin-left: 15px;">省级以上行业主管部门颁发的会展工程资质</span>
                                    </div>
                                </li>
                            </ul>
                            <div style="text-align: center; margin-top: 25px;">
                                <a class="btn2" id="sub-qyxx" href="javascript:;">提交申请</a>
                            </div>
                        </div>
                        <div id="box-status-1" style="display: none;">
                            <div class="xxsh">
                                <div class="sh-status" id="j-status-1">
                                    <p class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-wait.png" alt="">
                                        <span>企业信息正在审核中</span>
                                    </p>
                                </div>

                                <div class="sh-status" id="j-status-2">
                                    <p class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-false.png" alt="">
                                        <span>企业信息审核被驳回</span>
                                    </p>
                                    <p class="bhyy">驳回原因：</p>
                                    <p class="" style="text-align: center;">
                                        <a id="j-cxsq" class="btn2" href="javascript:;">重新申请</a>
                                    </p>
                                </div>
                                <div class="p4">
                                    <p><label for="">企业名称：</label><span class="company"></span></p>
                                    <p><label for="">社会统一信用代码：</label><span class="pay_tax"></span></p>
                                </div>
                            </div>
                        </div>
                        <div id="box-status-2" style="display: none;">
                            <div class="sqrz" id="">
                                <div class="xc-off">
                                    <div class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-true.png" alt="">
                                        <span>您提交的企业信息已通过审核</span>
                                    </div>
                                </div>
                                <div class="sqrz-con">
                                    <div class="top">
                                        <div><label for="">企业名称：</label><span class="company"></span></div>
                                        <div><label for="">社会统一信用代码：</label><span class="pay_tax"></span></div>
                                    </div>
                                    <div class="">
                                        <!-- <div class="item1">
                                            <div class="s-radio sqrz-type checked" value="2"><i></i><span>VIP会员</span>
                                            </div>
                                        </div> -->

                                        <div class="item2 sqrz-type-1">
                                            <div style="padding: 35px 0;">
                                                <div style="margin-bottom: 16px;">
                                                    <a class="btn"
                                                        href="../images/file/EXPOSCM平台普通会员服务协议.docx" download="EXPOSCM平台普通会员服务协议">下载入驻合同</a>
                                                    <span style="color: #E54C4A; margin-left: 10px;">*请加盖公章后回传合同</span>
                                                </div>
                                                <div class="s-flex-top">
                                                    <input type="file" accept="" id="ht-file" style="display: none;">
                                                    <a class="btn" id="ht-btn" href="javascript:;">回传入驻合同</a>
                                                    <ul class="ht-list" id="ht-list">
                                                        <!-- <li><span></span><i></i></li> -->
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="item2 sqrz-type-2">
                                            <div style="padding: 35px 0;">
                                                <div class="item3">
                                                    <div class="name">主场云</div>
                                                    <label for="">公&ensp;司&ensp;&ensp;名&ensp;称：</label>
                                                    <div class="input-block company" style="border: none">
                                                    </div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">管理员手机号：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="per_phone" name="per_phone"
                                                            type="text" placeholder="请输入" autocomplete="new-password">
                                                        <p class="tip">*此手机号用于主场云系统超级管理员登录</p>
                                                    </div>
                                                </div>
                                                <div class="item3 input-box">
                                                    <div class="name"></div>
                                                    <label for="">验&emsp;&ensp;证&ensp;&emsp;码：</label>
                                                    <div class="item3 input-block">
                                                        <input class="input-item" id="per_verification_code"
                                                            name="per_verification_code" type="text" placeholder="请输入"
                                                            autocomplete="new-password">
                                                    </div>
                                                    <a class="btn code-btn" id="btn-per_verification_code"
                                                        href="javascript:;">获取验证码</a>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="item2 sqrz-type-2">
                                            <div style="padding: 35px 0;">
                                                <div class="item3">
                                                    <div class="name">展装云</div>
                                                    <label for="">管理员账号名：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="bc_name" name="bc_name"
                                                            type="text" placeholder="请输入" autocomplete="new-password">
                                                        <p class="tip">*此账号用于展装云系统超级管理员登录</p>
                                                    </div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">设&ensp;置&ensp;&ensp;密&ensp;码：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="bc_password" name="bc_password"
                                                            type="password" placeholder="请输入登录密码"
                                                            autocomplete="new-password">
                                                        <img class="icon-img j-eye" src="../images/eye-0.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="item2">
                                            <div style="padding: 35px 0;">
                                                <div class="item3">
                                                    <div class="name">设计云</div>
                                                    <label for="">店 铺 名 称：</label>
                                                    <div class="input-block company" style="border: none">
                                                    </div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">登录手机号：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="design_phone" name="design_phone"
                                                            type="text" placeholder="请输入" autocomplete="new-password">
                                                    </div>
                                                </div>
                                                <div class="item3 input-box">
                                                    <div class="name"></div>
                                                    <label for="">验&emsp;证&emsp;码：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="design_verification_code"
                                                            name="design_verification_code" type="text"
                                                            placeholder="请输入" autocomplete="new-password">
                                                    </div>
                                                    <a class="btn code-btn" id="btn-design_verification_code"
                                                        href="javascript:;">获取验证码</a>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">设 置 密 码：</label>
                                                    <div class="input-block">
                                                        <input class="input-item" id="design_password"
                                                            name="design_password" type="password" placeholder="请输入登录密码"
                                                            autocomplete="new-password">
                                                        <img class="icon-img j-eye" src="../images/eye-0.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="sqrz-type-2 ">
                                    <div class="xy-box" style="margin-top: 20px;">
                                        <i class="s-checkbox" id="j-xieyi"></i>&ensp;
                                        <span>我已认真阅读并同意</span>
                                        <a class="" @click="showPdfPreview1" target="_blank"
                                            style="color: #5294F9;">《会展云平台VIP会员入驻协议》</a>
                                    </div>
                                </div>
                                <div style="text-align: center; margin-top: 30px;">
                                    <a id="sub-sqrz" class="btn2" href="javascript:;" style="width: 180px;">提交</a>
                                </div>
                            </div>
                        </div>
                        <div id="box-status-3" style="display: none;">
                            <div>
                                <div class="sh-status" id="j-status-4">
                                    <div class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-wait.png" alt="">
                                        <span>入驻信息正在审核中</span>
                                    </div>
                                </div>
                                <div class="sh-status" id="j-status-5">
                                    <p class="s-status" style="margin-bottom: 20px;">
                                        <img src="../images/icon-false.png" alt="">
                                        <span>入驻申请被驳回</span>
                                    </p>
                                    <p class="bhyy">驳回原因：</p>
                                    <p class="" style="text-align: center;margin-bottom: 20px;">
                                        <a id="j-cxrz" class="btn2" href="javascript:;">重新加入</a>
                                    </p>
                                </div>
                                <div class="sqrz-con">
                                    <div class="top">
                                        <div><label for="">企业名称：</label><span class="company"></span></div>
                                        <div><label for="">社会统一信用代码：</label><span class="pay_tax"></span></div>
                                    </div>
                                    <div class="item4">
                                        <div class="item5">
                                            <div class="sqrz-type-1-x">
                                                <p style="margin-bottom: 15px;">方式一(普通会员)</p>
                                                <div class="s-flex-top">
                                                    <a class="btn j-ht" href="javascript:;">查看合同</a>
                                                    <a class="btn j-ht-up" href="javascript:;">上传合同</a>
                                                    <!-- image/*,application/pdf -->
                                                    <input id="ht-file-2" type="file" accept="" style="display:none">
                                                    <ul class="ht-list ht-list2" id="">
                                                        <!-- <li><span></span><i></i></li> -->
                                                    </ul>
                                                    <a class="btn j-ht-up-sub" href="javascript:;"
                                                        style="margin-left: 10px;">提交</a>
                                                </div>
                                            </div>
                                            <div class="sqrz-type-2-x">
                                                <p>VIP会员</p>
                                                <a class="" @click="showPdfPreview1" target="_blank"
                                                    style="color: #5294F9; margin-top: 15px; display: block;">《会展云平台VIP会员入驻协议》</a>
                                            </div>
                                        </div>
                                        <div class="item6">
                                            
                                            <!-- <div class="sqrz-type-2-x">
                                                <div class="item3">
                                                    <div class="name">主场云</div>
                                                    <label for="">公&ensp;司&emsp;名&ensp;称：</label>
                                                    <div class="input-block company" style="border: none;"></div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">管理手机号名：</label>
                                                    <div class="input-block per_phone" style="border: none;"></div>
                                                </div>
                                            </div> -->
                                            <div class="sqrz-type-2-x" style="margin-top: 20px;">
                                                <div class="item3">
                                                    <div class="name">展装云</div>
                                                    <label for="">管理员账号名：</label>
                                                    <div class="input-block bc_name" style="border: none;"></div>
                                                </div>
                                            </div>
                                            <div style="margin-top: 20px;">
                                                <div class="item3">
                                                    <div class="name">设计云</div>
                                                    <label for="">店 铺 名 称：</label>
                                                    <div class="input-block company" style="border: none;"></div>
                                                </div>
                                                <div class="item3">
                                                    <div class="name"></div>
                                                    <label for="">登录手机号：</label>
                                                    <div class="input-block design_phone" style="border: none;"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bottom-box">
                                        <div class="bottom">
                                            <span class="s1">付款状态：</span>
                                            <div class="pay_status pay_status_all_0">
                                                <div class="s-flex">
                                                    <span class="s2">未到款</span>
                                                    <a class="btn btn-pay" href="javascript:;">去付款</a>
                                                </div>
                                            </div>
                                            <div class="pay_status pay_status_all_1">
                                                <span class="s1">已到款</span>
                                            </div>
                                            <div class="pay_status pay1_margin0">
                                                <p class="s1">第三方系统服务费已到款</p>
                                                <p class="s2">诚信保证金未到款，请将诚信保证金汇入合同</p>
                                            </div>
                                            <div class="pay_status pay0_margin1">
                                                <div class="s-flex">
                                                    <span class="s2">第三方系统服务费未到款</span>
                                                    <a class="btn btn-pay" href="javascript:;">去付款</a>
                                                </div>
                                                <span class="s1">诚信保证金已到款</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="box-status-4" style="display: none;">

                            <div class="sqrz-con">
                                <div class="top2">
                                    <div>
                                        <p><label class="s1" for="">企业名称：</label><span class="s2 company"></span></p>
                                        <p><label class="s1" for="">入驻时间：</label><span class="s2 create_time"></span>
                                        </p>
                                    </div>
                                    <div>

                                        <p><label class="s1" for="" style="color: #6c6c6c;">社会统一信用代码：</label><span class="s2 pay_tax"  style="color: #6c6c6c;"></span>
                                        </p>
                                        <p class="xfTime1"><label class="s1" for=""  style="color: #6c6c6c;">到&emsp; 期&emsp; 时 &emsp;间：</label><span
                                                class="s2 end_time"  style="color: #6c6c6c;"></span></p>
                                        <p class="xfTime2"><label class="s1" for=""  style="color: #6c6c6c;">续&emsp; 费&emsp; 时 &emsp;间：</label><span class="s2 create_time"  style="color: #6c6c6c;"></span></p>
                                    </div>
                                    <div class="xfTime2">
                                        <p style="opacity: 0;"><label class="s1" for="">企业名称：</label><span class="s2 company"></span></p>
                                        <p><label class="s1" for=""  style="color: #6c6c6c;">到&emsp; 期&emsp; 时 &emsp;间：</label><span
                                                class="s2 end_time" style="color: #6c6c6c;"></span></p>
                                    </div>
                                </div>
                                <div class="item4">
                                    <div class="item5">
                                        <div class="sqrz-type-1-x">
                                            <p style="margin-bottom: 15px;">方式一(普通会员)</p>
                                            <div class="s-flex-top">
                                                <a class="btn j-ht" href="javascript:;">查看合同</a>
                                                <a class="btn j-ht-up" href="javascript:;">上传合同</a>
                                                <ul class="ht-list ht-list2" id="">
                                                    <!-- <li><span></span><i></i></li> -->
                                                </ul>
                                                <a class="btn j-ht-up-sub" href="javascript:;"
                                                    style="margin-left: 10px;">提交</a>
                                            </div>
                                        </div>
                                        <div class="sqrz-type-2-x">
                                            <p>VIP会员</p>
                                            <a class="" @click="showPdfPreview1"
                                                style="color: #5294F9; margin-top: 15px; display: block;">《会展云平台VIP会员入驻协议》</a>
                                        </div>
                                    </div>
                                    <div class="item6 noSq">
                                        
                                        <!-- <div class="sqrz-type-2-x">
                                            <div class="item3">
                                                <div class="name">主场云</div>
                                                <label for="">公&ensp;司&emsp;名&ensp;称：</label>
                                                <div class="input-block company" style="border: none;"></div>
                                            </div>
                                            <div class="item3">
                                                <div class="name"></div>
                                                <label for="">管理手机号名：</label>
                                                <div class="input-block per_phone" style="border: none;"></div>
                                            </div>
                                        </div> -->
                                        <div class="sqrz-type-2-x" style="margin-top: 20px;">
                                            <div class="item3">
                                                <div class="name">展装云</div>
                                                <label for="">管理员账号名：</label>
                                                <div class="input-block bc_name" style="border: none;"></div>
                                            </div>
                                        </div>
                                        <div style="margin-top: 20px;">
                                            <div class="item3">
                                                <div class="name">设计云</div>
                                                <label for="">店 铺 名 称：</label>
                                                <div class="input-block company" style="border: none;"></div>
                                            </div>
                                            <div class="item3">
                                                <div class="name"></div>
                                                <label for="">登录手机号：</label>
                                                <div class="input-block design_phone" style="border: none;"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="yesSq" style="width:50%;height:200px; display: flex;flex-direction: column;justify-content: center;">
                                        <div>
                                            <img style="width: 20px; height: 20px;" src="../images/web1.png" alt="">
                                            <span>恭喜成为会展云平台VIP会员！您的专属会员客服恭候多时！</span>
                                        </div>
                                        <div style="display: flex;margin-top: 30px;">
                                            <img style="width: 95px; height: 95px;" src="../images/web3.png" alt="">
                                            <div style="margin-left: 20px;padding: 3px 0; font-size: 18px;color: #000;font-weight: 500;display: flex;flex-direction: column;justify-content: space-between;">
                                                <!-- <div>客服：曹洁</div> -->
                                                <div>电话：010-86460766-865</div>
                                                <div>邮箱：customerservice@exposaas.com</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="bottom-box">
                                    <div class="bottom">
                                        <span class="s1">付款状态：</span>
                                        <div class="pay_status pay_status_all_0"  id="pay_status_all_0">
                                            <div class="s-flex">
                                                <span class="s2">未到款</span>
                                                <a class="btn btn-pay" href="javascript:;">去付款</a>
                                            </div>
                                        </div>
                                        <div class="pay_status pay_status_all_1" id="pay_status_all_1">
                                            <span class="s1">已到款</span>
                                        </div>
                                        <div class="pay_status pay1_margin0">
                                            <p class="s1">第三方系统服务费已到款</p>
                                            <p class="s2">诚信保证金未到款，请将诚信保证金汇入合同</p>
                                        </div>
                                        <div class="pay_status pay0_margin1">
                                            <div class="s-flex">
                                                <span class="s2">第三方系统服务费未到款</span>
                                                <a class="btn btn-pay" href="javascript:;">去付款</a>
                                            </div>
                                            <span class="s1">诚信保证金已到款</span>
                                        </div>
                                    </div>
                                    <div class="bottom xfAlign">
                                        <span class="s1">开票状态：</span>
                                        <span class="s1 j-invoice-status">已申请</span>
                                        <span class="s1 j-invoice-status2" style="color:red">已冲红</span>
                                        <span class="s1 j-invoice-status3" style="color:red">已驳回</span>
                                        <span class="s1 j-invoice-status4">已开票</span>

                                        <a class="a1 j-invoice-get" href="javascript:;">申请发票</a>
                                        <span class="a1 j-invoice-down" style="cursor: pointer;" href="">下载发票</span>
                                        <a class="a1 j-invoice-detail" href="javascript:;">发票详情</a>
                                        <a class="a1 j-invoice-edit" href="javascript:;">修改发票信息</a>
                                        <a class="a1 j-invoice-edit2" href="javascript:;">重新申请</a>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <!-- 续费 -->
                    <div class="xf-box" id="j-xf">
                        <p id="xf-msg">您的会员还有10日即将到期</p>
                        <a id="btn-xf" class="btn2" href="javascript:;">会员续费</a>
                    </div>
                </div>
            </section>
        </div>
        <h4 id="lxwm" class="title5" style="margin-top: 70px; margin-bottom: 30px;">联系我们</h4>
        <div class="bg4">
            <div class="bg3">
                <div class="col box-lxwm">
                    <dl>
                        <dt>企微客服</dt>
                        <dt><img src="../images/img-kf4.png" alt=""></dt>
                        <dt>咨询热线</dt>
                        <dd>010-86460766-861</dd>
                        <!-- <dt>咨询邮箱</dt>
                        <dd>pangbo@exposaas.com</dd> -->
                    </dl>
                </div>
            </div>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>

    <!-- 付款 -->
    <div class="dialog-box" id="j-pay-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">订单付款</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <div class="pay-con">
                        <div class="div1">
                            <div>
                                <p class="p1" style="border: none;font-size: 18px;margin-bottom: 20px;"><label for="">企&emsp;&ensp;业&emsp;名&emsp;&ensp;称：</label><span
                                        class="company" style="color: #000;"></span></p>
                                <p class="p1" style="border: none;font-size: 18px;margin-bottom: 20px; "><label for="">社会统一信用代码：</label><span class="pay_tax" style="color: #000;"></span></p>
                            </div>
                        </div>
                        <div class="p2 sqrz-type-1">方式一（普通会员）</div>
                        <div class="p2 sqrz-type-2 isvipxf">VIP会员</div>
                        <div class="p3">
                            <div class="s-radio pay-type checked" value="1" style="margin-right: 70px;">
                                <i></i><span>线上付款</span></div>
                            <div class="s-radio pay-type" value="2"><i></i><span>线下付款</span></div>
                        </div>
                        <div class="pay-type-2">
                            <div class="p4">待付金额</div>
                            <table class="table1 sqrz-type-1">
                                <tr>
                                    <td>诚信保证金</td>
                                    <td class="td2 margin_free"></td>
                                </tr>
                                <tr>
                                    <td>第三方系统服务费</td>
                                    <td class="td2 pay_price"></td>
                                </tr>
                                <tr>
                                    <td class="td2" colspan="2">合计 <span class="margin_free_pay_price"></span></td>
                                </tr>
                            </table>
                            <table class="table1 sqrz-type-2">
                                <tr>
                                    <td>第三方系统服务费</td>
                                    <td class="td2 pay_price"></td>
                                </tr>
                            </table>
                            <div class="p4">对公账户</div>
                            <div class="div2">
                                <p>开户行：<span class="bank">招商银行北京分行华贸中心支行</span></p>
                                <p>户&emsp;名：<span class="company1">云融会展（上海）有限公司</span></p>
                                <p>帐&emsp;号：<span class="account">110926563210301</span></p>
                            </div>
                            <p class="p5">如已完成汇款，请等待后台审核</p>
                            <div style=" margin-top: 20px; text-align: center;">
                                <a id="btn-pay-sub" class="btn2" href="javascript:;">确定</a>
                            </div>
                        </div>
                        <div class="pay-type-1">
                            <div class="div3">
                                <span class="sqrz-type-1 pay_price"></span>
                                <span class="sqrz-type-2 pay_price"></span>
                                <div class="img1" id="pay-img"></div>
                                <p class="p6"><img src="../images/icon-wx.png" alt=""><span>微信扫码支付</span></p>
                                <!-- <p class="p5">请将诚信保证金汇入合同所显示的对公账户内</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 申请发票 -->
    <div class="dialog-box" id="j-invoice-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">申请发票</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <form class="form-invoice" id="form-invoice">
                        <ul class="s-form">
                            <div class="p1">开票信息</div>
                            <!-- <li class="item">
                                <label for="">发票金额</label>
                                <input class="form-input input-pay_tax" type="text" maxlength="30"
                                    name="invoicePrice" style="border: none;" readonly="readonly">
                            </li> -->
                            <li class="item">
                                <label for="">发票类型</label>
                                <div class="s-radio invoice-radio checked" value="1" style="margin-right: 45px;">
                                    <i></i><span>增值税普通发票</span></div>
                                <div class="s-radio invoice-radio" value="2"><i></i><span>增值税专用发票</span></div>
                            </li>
                            <li class="item">
                                <label for="">发票抬头</label>
                                <!-- <div class="company"></div> -->
                                <input class="form-input input-company" type="text" maxlength="50"
                                    name="company_invoice_title" >
                            </li>
                            <li class="item">
                                <label for="">公司税号</label>
                                <!-- <div class="pay_tax"></div> -->
                                <input class="form-input input-pay_tax" type="text" maxlength="30"
                                    name="company_invoice_tax_number" >
                            </li>
                            <!-- <li class="item">
                                <label for="">开户银行</label>
                                <input class="form-input" type="text" maxlength="20" name="company_invoice_bank">
                            </li>
                            <li class="item">
                                <label for="">开户账号</label>
                                <input class="form-input" type="text" maxlength="30"
                                    name="company_invoice_bank_account">
                            </li>
                            <li class="item">
                                <label for="">注册地址</label>
                                <input class="form-input" type="text" maxlength="100" name="company_invoice_address">
                            </li>
                            <li class="item">
                                <label for="">注册电话</label>
                                <input class="form-input" type="text" name="company_invoice_phone">
                            </li> -->
                            <!-- <div class="p1 invoice-type-2" style="margin-top: 30px;">邮寄信息</div>
                            <li class="item invoice-type-2">
                                <label for="">所属地区</label>
                                <div class="form-input-block" data-toggle="distpicker" id="distpicker">
                                    <select class="form-input" name="province" ></select>
                                    <select class="form-input" name="city" ></select>
                                    <select class="form-input" name="district" ></select>
                                </div>
                            </li>
                            
                            <li class="item invoice-type-2">
                                <label for="">详细地址</label>
                                <input class="form-input" type="text" maxlength="100" name="mailing_address">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系人</label>
                                <input class="form-input" type="text" maxlength="20" name="mailing_username">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系电话</label>
                                <input class="form-input" type="text" name="mailing_phone">
                            </li> -->

                            <div class="p1 invoice-type-1" style="margin-top: 30px;">联系人</div>
                            <li class="item invoice-type-1">
                                <label for="">电子邮箱</label>
                                <input class="form-input" type="text" name="mailing_email">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系人</label>
                                <input class="form-input" type="text" maxlength="20" name="mailing_username">
                            </li>
                            <li class="item invoice-type-2">
                                <label for="">联系电话</label>
                                <input class="form-input" type="text" name="mailing_phone">
                            </li> 
                        </ul>
                        <div style="text-align: center;">
                            <a id="sub_apply_invoice" class="btn" href="javascript:;">提交</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- 申请详情 -->
    <div class="dialog-box" id="j-invoice-detail-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">开票详情</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <div class="invoice-detail" id="invoice-detail">
                        <div style="display: flex;justify-content: space-between;">
                          <div class="status-bar">
                            <div class="icon">
                                <img src="../images/icon-true.png" alt="">
                                <div class="textCon">开票中</div>
                            </div>
                            <div class="line hideLine"></div>
                            <div class="icon hideIcon">
                                <img class="img2" src="../images/icon-true-2.png" alt="">
                                <img class="img1" src="../images/icon-true.png" alt="">
                                <div>已完成</div>
                            </div>
                        </div>
                        <el-button class="isBtnShow" type="primary" style="height: 40px;" @click="downFp">下载发票</el-button>
                        </div>
                        
                        <ul class="s-form">
                            <div class="p1">开票信息</div>
                            <li class="item">
                                <label for="">发票金额</label>
                                <div class="invoicePrice"></div>
                            </li>
                            <li class="item">
                                <label for="">发票类型</label>
                                <div class="invoice_type"></div>
                            </li>
                            <li class="item">
                                <label for="">发票抬头</label>
                                <div class="company_invoice_title"></div>
                            </li>
                            <li class="item">
                                <label for="">公司税号</label>
                                <div class="company_invoice_tax_number"></div>
                            </li>
                            <!-- <li class="item _j-type-2">
                                <label for="">开户银行</label>
                                <div class="company_invoice_bank"></div>
                            </li>
                            <li class="item _j-type-2">
                                <label for="">开户账号</label>
                                <div class="company_invoice_bank_account"></div>
                            </li>
                            <li class="item _j-type-2">
                                <label for="">注册地址</label>
                                <div class="company_invoice_address"></div>
                            </li>
                            <li class="item _j-type-2">
                                <label for="">注册电话</label>
                                <div class="company_invoice_phone"></div>
                            </li> -->
                            <li class="item">
                                <label for="">申请时间</label>
                                <div class="create_time"></div>
                            </li>
                            <!-- <div class="p1 j-type-2" style="margin-top: 30px;">邮寄信息</div>
                            <li class="item j-type-2">
                                <label for="">邮寄地址</label>
                                <div class="mailing_address"></div>
                            </li>
                            <li class="item j-type-2">
                                <label for="">联系人</label>
                                <div class="mailing_username"></div>
                            </li>
                            <li class="item j-type-2">
                                <label for="">联系电话</label>
                                <div class="mailing_phone"></div>
                            </li> -->
                            <div class="p1 j-type-1" style="margin-top: 30px;">联系人</div>
                            <li class="item j-type-1">
                                <label for="">电子邮箱</label>
                                <div class="mailing_email"></div>
                            </li>
                            <li class="item j-type-1">
                                <label for="">联系人</label>
                                <div class="company_invoice_contact"></div>
                            </li>
                            <li class="item j-type-1">
                                <label for="">联系电话</label>
                                <div class="company_invoice_phone"></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 查看合同 -->
    <div class="dialog-box" id="j-ht-dialog">
        <div class="dialog-bg">
            <div class="dialog">
                <div class="d-head">
                    <span class="d-title">合同</span>
                    <img class="d-close" src="../images/icon-no.svg" alt="">
                </div>
                <div class="d-con">
                    <ul class="look-ht-list" id="look-ht-list">
                        <!-- <li><a href="" target="_blank"></a></li> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
    <script>
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    import activity from  '@/js/activity';
    import '@/js/distpicker';
    export default {
        name:'activity',
        mixins:[activity],
        components: {
            headers,
            footers,
            contact,
        },
        computed: {},
        mounted(){
        },
        methods:{
            showPdfPreview1(){
                window.open('https://www.exposcm.com/member.pdf')
            },
        }
    }
</script>
<style scoped>
.dlStyule {
    justify-content: center;
}
.dlStyule>dl {
    flex: unset !important;
    
}
.table1 th {
    vertical-align: middle;
}
.table1 td {
    vertical-align: middle;
}
.p1 {
    border: none;
    padding-top: 0;
    padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/page/activity.vue